import { ActiveRecord } from '../../models/record';

export class SetActiveRecord {
  static readonly type = '[Home] Set active record';

  constructor(public record?: ActiveRecord) {}
}

export class ResetStore {
  static readonly type = '[Home] Reset store';
}
